import React, { useContext } from "react";
import { TableRow, TableCell } from "@material-ui/core";
import AppContext from "context/Context";
import { Database } from "lucide-react";
import "./TableEmptyState.css";

const TableEmptyState = ({
  colSpan = 10,
  message = "No data available",
  align = "center",
  className = "dataCell",
  height,
  icon: CustomIcon,
}) => {
  const {
    config: { isDark },
  } = useContext(AppContext);

  const IconComponent = CustomIcon || Database;

  return (
    <TableRow style={{ height: height }}>
      <TableCell align={align} className={`${className} table-empty-cell`} colSpan={colSpan}>
        <div className={`table-empty-wrapper`}>
          <div className="table-empty-icon">
            <IconComponent size={32} color={isDark ? "#374151" : "#E5E7EB"} strokeWidth={1.5} />
          </div>
          <p className="table-empty-message">{message}</p>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default TableEmptyState;
